import { Box, Chip, Grid, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { Refresh, Save } from '@mui/icons-material';

import { CustomButton } from '../../../../common/components';
import { MONTH_OPTIONS } from '../../constants/puntajeConstants';
import LotteryResultsTable from './LotteryResultsTable';

const LotteryTab = ({
  isAdmin,
  lotteryRows,
  lotteryForm,
  setLotteryForm,
  isLoading,
  pagination,
  syncLoading,
  saveLoading,
  onSync,
  onSave,
}) => (
  <Stack spacing={3}>
    <Paper elevation={0} sx={{ p: 2.5, borderRadius: 0 }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', md: 'center' }}
        spacing={2}
        sx={{ mb: 2 }}
      >
        <Box>
          <Typography variant="h6">Numeros de Loteria</Typography>
          <Typography variant="body2" color="text.secondary">
            Todos los resultados sincronizados desde Nacional Loteria o cargados manualmente.
          </Typography>
        </Box>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
          <Chip
            label={
              pagination?.totalCount ? `${pagination.totalCount} registro(s)` : 'Sin registros'
            }
            color={pagination?.totalCount ? 'primary' : 'default'}
            variant="outlined"
          />
          <CustomButton
            variant={isAdmin ? 'outlined' : 'text'}
            buttonIcon={Refresh}
            onClick={onSync}
            disabled={!isAdmin}
            isLoading={syncLoading}
            sx={{ height: 40 }}
          >
            Sincronizar
          </CustomButton>
        </Stack>
      </Stack>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            fullWidth
            type="number"
            label="Año"
            value={lotteryForm.year}
            onChange={(event) =>
              setLotteryForm((prev) => ({
                ...prev,
                year: event.target.value,
              }))
            }
            disabled={!isAdmin}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            fullWidth
            label="Mes"
            value={lotteryForm.month}
            onChange={(event) =>
              setLotteryForm((prev) => ({
                ...prev,
                month: event.target.value,
              }))
            }
            disabled={!isAdmin}
          >
            {MONTH_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            fullWidth
            type="date"
            label="Fecha"
            value={lotteryForm.draw_date}
            onChange={(event) =>
              setLotteryForm((prev) => ({
                ...prev,
                draw_date: event.target.value,
              }))
            }
            disabled={!isAdmin}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            fullWidth
            label="Numero completo"
            value={lotteryForm.full_number}
            onChange={(event) =>
              setLotteryForm((prev) => ({
                ...prev,
                full_number: event.target.value,
              }))
            }
            disabled={!isAdmin}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="URL fuente"
            value={lotteryForm.source_url}
            onChange={(event) =>
              setLotteryForm((prev) => ({
                ...prev,
                source_url: event.target.value,
              }))
            }
            disabled={!isAdmin}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="URL screenshot"
            value={lotteryForm.screenshot_url}
            onChange={(event) =>
              setLotteryForm((prev) => ({
                ...prev,
                screenshot_url: event.target.value,
              }))
            }
            disabled={!isAdmin}
          />
        </Grid>
        <Grid item xs={12} md={10}>
          <TextField
            fullWidth
            label="Observaciones"
            value={lotteryForm.observations}
            onChange={(event) =>
              setLotteryForm((prev) => ({
                ...prev,
                observations: event.target.value,
              }))
            }
            disabled={!isAdmin}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CustomButton
            fullWidth
            variant={isAdmin ? 'base' : 'outlined'}
            buttonIcon={Save}
            onClick={onSave}
            disabled={!isAdmin}
            isLoading={saveLoading}
            sx={{ height: '100%' }}
          >
            Guardar
          </CustomButton>
        </Grid>
      </Grid>

      <LotteryResultsTable rows={lotteryRows} isLoading={isLoading} pagination={pagination} />
    </Paper>
  </Stack>
);

export default LotteryTab;
